import MobileMenuLevels from './mobile-menu';
import PhoneMobile from './phone-mobile';
import WrapModalCatalog from './wrap-modal-catalog';
import ButtonModalCatalog from './submit-drop-modal';
import ButtonChangeRegions from './button-change-regions';
import UndefineRegions from './undefine-regions';

window.addEventListener('DOMContentLoaded', () => {
    const buttonOpenClose = document.querySelector('.header-mobile__burger');
    const buttonPhone = document.querySelector('.header-mobile__phone-open');
    const buttonModalCatalog = document.getElementById('header-desktop__catalog-button');
    const modalDOM = document.querySelector('.header__nav-item-catalog');
    const buttonsChangeRegions = document.querySelector('.header-desktop__regions-current');
    const mobileButtonsChangeRegions = document.querySelector('.mobile-menu__change-region-submit');

    const mobileMenu = new MobileMenuLevels(buttonOpenClose);

    new UndefineRegions('.modal-regions-undefined__choose');
    new ButtonChangeRegions(mobileButtonsChangeRegions);
    new ButtonChangeRegions(buttonsChangeRegions);
    new ButtonModalCatalog(buttonModalCatalog);
    new WrapModalCatalog(modalDOM, mobileMenu);
    new PhoneMobile(buttonPhone);
});
